/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';

import { object } from 'prop-types';
import { compose } from 'recompose';
import { useDispatch } from 'react-redux';
import {
    Dialog, DialogContent, withStyles, DialogTitle, Grid,
} from '@material-ui/core';
import NativeSigninUIComponent from './NativeSigninUIComponent';
import CloseRounded from '../../EmailOptIn/Images/x-close.png';
import { emitCustomTrackingEvent } from '../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { setNativeLoginPromptRefetchTimestamp, setNativeLoginPromptSFResponse } from '../../../../state/ducks/App/App-Actions';
import { fetchUserEmailbyBrowserUUID } from '../../../../apis/account-apis/fetchUserEmailbyBrowserUUID';

const styles = (theme) => ({
    dialogContainer: {
        '& .MuiDialog-scrollPaper': {
            '@media (min-width: 768px)': {
                justifyContent: 'end !important',
                marginRight: '10px !important',
            },
            [theme.breakpoints.down(500)]: {
                alignItems: 'end !important',
            },
            '& .MuiPaper-root': {
                borderRadius: '10px',
                margin: '0px !important',
                [theme.breakpoints.down(500)]: {
                    margin: '10px !important',
                    width: '100%',
                    marginBottom: '-10px !important',
                },
                '& .MuiDialogContent-root': {
                    padding: '0px !important',
                    '& .MuiPaper-root': {
                        boxShadow: 'none !important',
                    },
                },
            },
            '& h1': {
                fontSize: '20px !important',
                lineHeight: '30px !important',
            },
            '& .privacyPolicyBlock': {
                fontSize: '10px',
                lineHeight: '15px',
                '& a': {
                    margin: '0px 4px 0px 4px',
                },
            },
            '& .login': {
                '& .MuiFormControl-root': {
                    marginTop: '10px',
                },
            },
            '& .mainContainer': {
                backgroundColor: 'white !important',
                '& .MuiCardContent-root': {
                    padding: '0px 30px !important',
                    [theme.breakpoints.down(500)]: {
                        paddingBottom: '30px !important',
                    },
                },
            },
        },
    },
    closeIconWrapper: {
        color: 'rgba(0, 0, 0, 0.6)',
        position: 'absolute',
        right: '10px',
        top: '10px',
        cursor: 'pointer',
    },
});

const NativeSignInPrompt = ({ classes, salesForceData, page }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [emailId, setEmailId] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        const userEmailAPICall = async () => {
            const userEmailID = await fetchUserEmailbyBrowserUUID();
            setEmailId(userEmailID);
        };
        userEmailAPICall();
        setTimeout(() => {
            const userGroup = salesForceData?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
            if (userGroup?.toLowerCase?.() === 'test') setIsOpen(true);
            dispatch(emitCustomTrackingEvent({
                action: 'Impression',
                salesforceResponse: salesForceData,
                page,
                eventSubType: 'campaign-tracking',
            }));
            const currentTime = new Date().getTime();
            dispatch(setNativeLoginPromptRefetchTimestamp(currentTime));
            dispatch(setNativeLoginPromptSFResponse(salesForceData));
        }, 10000);
    }, []);

    return (
        <>
            <Dialog
                id="native-sign-in-prompt"
                open={isOpen}
                hideBackdrop
                disableEnforceFocus
                disableBackdropClick
                disableScrollLock
                data-testid="native-sign-in-prompt"
                className={classes.dialogContainer}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Grid item container>
                        <Grid
                            item
                            className={classes.closeIconWrapper}
                            onClick={() => { setIsOpen(false); }}
                            id="native-sign-in-prompt-close-button"
                            data-testid="native-sign-in-prompt-close-button"
                        >
                            <img src={CloseRounded} alt="close-btn-img" className={classes.closeIcon} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <NativeSigninUIComponent isPrompt emailId={emailId} />
                </DialogContent>
            </Dialog>
        </>
    );
};

NativeSignInPrompt.propTypes = {
    classes: object.isRequired,
    salesForceData: object.isRequired,
    page: object.isRequired,
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(NativeSignInPrompt);
